/* eslint-disable camelcase */
import * as React from 'react';
import styles from './styles';
import {
  AppBar,
  Box,
  Grid,
  Typography,
} from '@mui/material';
import Premium from '../../../../assets/images/PRO logo PMS green only.svg';
import { HYDRAULICS_URL } from '../../../../shared/config/config';

export default function HydraulicsNavbar() {
  const classes = styles();

  return (
      <>
          <Box className={classes.fixedAppbar} sx={{ background: '#000' }}>
              <AppBar elevation={0} position="static" className={classes.toolBar}>
                  <Grid container justifyContent='space-between' alignItems='center'>
                      <Box
                          component="img"
                          alt="Logo"
                          src={Premium}
                          className={classes.logo}
                      />
                      <Box display='flex' alignItems='center'>
                          <Typography>
                            <a href={HYDRAULICS_URL} className={classes.text}>Let’s Get Started</a>
                          </Typography>
                      </Box>
                  </Grid>
              </AppBar>
          </Box>
      </>
  );
}
